import { ResponseTri, RequestTri } from '../../shared/interfaces';
import { createReducer, on } from '@ngrx/store';
import { TriActions } from '../actions';
import { TriTypes } from '../../shared/enums';

export interface TriState {
    response: ResponseTri;
    request: RequestTri;
    error: any;
}

export const TriInitialState: TriState = {
    response: null,
    request: null,
    error: null
};

const _triReducer = createReducer(
    TriInitialState,

    on(TriActions.getTri, (state) => ({
        ...state,
        request: null,
        error: null
    })),

    on(TriActions.getTriSucess, (state, { response }) => ({
        ...state,
        response,
        error: null
    })),

    on(TriActions.getTriError, (state, { payload }) => ({
        ...state,
        request: null,
        response: null,
        error: {
            statusCode: payload.statusCode,
            message: payload.message
        }
    })),

    on(TriActions.cleanState, (state) => ({
        ...state,
        request: null,
        response: null,
        error: null
    }))
);

export function triReducer(state, action) {
    if (action.type === TriTypes.TRI) {
        state = undefined;
    }
    return _triReducer(state, action);
}
